import DESKTOP_CHART from "../assets/chart-desktop.svg";
import MOBILE_CHART from "../assets/chart-mobile.svg";
import TABLET_CHART from "../assets/chart-tablet.svg";

export const StaticChart: React.FC = () => {
  return (
    <div className="w-full flex items-center justify-start">
      <div className="flex  flex-col justify-start items-start gap-3">
        <p className="text-white font-quicksand text-[14px] font-normal leading-[24px] opacity-80">
          {"Utveckling"}
        </p>

        <div className="flex flex-col justify-end">
          <img
            src={MOBILE_CHART}
            alt="main-photo"
            className="rounded-t-lg sm:hidden object-cover"
          />
          <img
            src={TABLET_CHART}
            alt="main-photo"
            className="hidden sm:block lg:hidden rounded-t-lg sm:rounded-t-none object-cover"
          />
          <img
            src={DESKTOP_CHART}
            alt="main-photo"
            className="hidden lg:block rounded-t-lg sm:rounded-t-none lg:rounded-r-lg object-cover"
          />
        </div>
      </div>
    </div>
  );
};
